webpackJsonp([241484898055111],{

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeroBanner = function (_Component) {
	  _inherits(HeroBanner, _Component);
	
	  function HeroBanner(props) {
	    _classCallCheck(this, HeroBanner);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.createArrow = _this.createArrow.bind(_this);
	    _this.randomBounceArrow = _this.randomBounceArrow.bind(_this);
	    _this.doScrolling = _this.doScrolling.bind(_this);
	    _this.getElementY = _this.getElementY.bind(_this);
	    return _this;
	  }
	
	  HeroBanner.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var heroBanner = document.getElementById(this.props.heroId);
	    var nextSection = document.getElementById(this.props.nextId);
	    var scrollDownArrow = this.createArrow();
	
	    scrollDownArrow.addEventListener('click', this.doScrolling.bind(null, nextSection, 1500));
	    scrollDownArrow.addEventListener('animationend', function () {
	      scrollDownArrow.classList.remove('bounce');
	
	      _this2.randomBounceArrow(scrollDownArrow, 5000, 12000);
	    });
	
	    // Append to element
	    heroBanner.append(this.randomBounceArrow(scrollDownArrow, 5000, 12000));
	  };
	
	  HeroBanner.prototype.getElementY = function getElementY(query) {
	    if (typeof query == "object") return window.pageYOffset + query.getBoundingClientRect().top;else return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top;
	  };
	
	  HeroBanner.prototype.doScrolling = function doScrolling(element, duration) {
	    var startingY = window.pageYOffset;
	    var elementY = this.getElementY(element);
	    // If element is close to page's bottom then window will scroll only to some position above the element.
	    var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
	    var diff = targetY - startingY;
	    // Easing function: easeInOutCubic
	    // From: https://gist.github.com/gre/1650294
	    var easing = function easing(t) {
	      return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
	    };
	    var start;
	
	    if (!diff) return;
	
	    // Bootstrap our animation - it will get called right before next frame shall be rendered.
	    window.requestAnimationFrame(function step(timestamp) {
	      if (!start) start = timestamp;
	      // Elapsed miliseconds since start of scrolling.
	      var time = timestamp - start;
	      // Get percent of completion in range [0, 1].
	      var percent = Math.min(time / duration, 1);
	      // Apply the easing.
	      // It can cause bad-looking slow frames in browser performance tool, so be careful.
	      percent = easing(percent);
	
	      window.scrollTo(0, startingY + diff * percent);
	
	      // Proceed with animation as long as we wanted it to.
	      if (time < duration) {
	        window.requestAnimationFrame(step);
	      }
	    });
	  };
	
	  HeroBanner.prototype.createArrow = function createArrow() {
	    var arrowButton = document.createElement('button');
	
	    arrowButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.6 18.32"><path d="M15.78,12.56l-3-3L9.11,5.9,5.94,2.73c-.51-.52-1-1-1.54-1.54l0,0A2.35,2.35,0,0,0,2.77.5a2.3,2.3,0,0,0-1.6.67A2.26,2.26,0,0,0,.5,2.77a2.35,2.35,0,0,0,.67,1.61l1.29,1.3,3.11,3.1,3.71,3.71,3.14,3.14c.46.46.91.94,1.38,1.39a2.89,2.89,0,0,0,4,0l.12-.12.72-.72,2.82-2.82,3.68-3.68,3.35-3.36,1.86-1.85.08-.09a2.35,2.35,0,0,0,.67-1.61,2.3,2.3,0,0,0-.67-1.6A2.26,2.26,0,0,0,28.82.5a2.34,2.34,0,0,0-1.6.67h0L26,2.43l-3,3L19.27,9.11C18.22,10.16,16.83,11.51,15.78,12.56Z"/></svg>';
	    arrowButton.setAttribute('title', 'Click here or scroll down to view more');
	    arrowButton.setAttribute('class', 'more');
	
	    return arrowButton;
	  };
	
	  HeroBanner.prototype.randomBounceArrow = function randomBounceArrow(element, minTime, maxTime) {
	    setTimeout(function () {
	      element.classList.add('bounce');
	    }, Math.floor(Math.random() * maxTime + minTime));
	
	    return element;
	  };
	
	  HeroBanner.prototype.render = function render() {
	    var children = this.props.children;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'fs fs-more', id: this.props.heroId, 'data-next': this.props.nextId },
	      children
	    );
	  };
	
	  return HeroBanner;
	}(_react.Component);
	
	exports.default = HeroBanner;
	module.exports = exports['default'];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Project = function (_Component) {
	  _inherits(Project, _Component);
	
	  function Project() {
	    _classCallCheck(this, Project);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Project.prototype.toggleDetails = function toggleDetails(elem) {
	
	    var projectContainer = this.parent(elem.target),
	        activeProject = document.querySelector('.project.active');
	
	    if (projectContainer.classList.contains('active')) this.collapseDetails(projectContainer);else {
	      if (activeProject) this.collapseDetails(activeProject);
	
	      this.expandDetails(projectContainer);
	    }
	  };
	
	  Project.prototype.expandDetails = function expandDetails(element) {
	    var detailsContainer = element.querySelector('.details');
	
	    element.classList.add('active');
	    element.style.paddingBottom = detailsContainer.clientHeight + 'px';
	  };
	
	  Project.prototype.collapseDetails = function collapseDetails(element) {
	    element.classList.remove('active');
	    element.style.paddingBottom = '0px';
	  };
	
	  Project.prototype.parent = function parent(element) {
	    while (!element.classList.contains('project')) {
	      element = element.parentNode;
	    }
	
	    return element;
	  };
	
	  Project.prototype.render = function render() {
	    var data = this.props.data;
	    var frontmatter = data.frontmatter;
	    var html = data.html;
	
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'project' },
	      _react2.default.createElement(
	        'header',
	        { style: { 'backgroundImage': 'url(' + frontmatter.hero.publicURL + ')' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'inner' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            frontmatter.title
	          ),
	          _react2.default.createElement(
	            'h4',
	            null,
	            frontmatter.overview
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'button',
	                { onClick: this.toggleDetails.bind(this) },
	                'Details'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              frontmatter.website && _react2.default.createElement(
	                'a',
	                { href: frontmatter.website },
	                'Website'
	              ),
	              !frontmatter.website && _react2.default.createElement(
	                'a',
	                { href: 'javascript:void(0)' },
	                'In development'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'details' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper story' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Project Details'
	            )
	          ),
	          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: html } }),
	          _react2.default.createElement(
	            'div',
	            null,
	            frontmatter.tags.length > 0 && _react2.default.createElement(
	              'div',
	              { className: 'tags' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Services'
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'simple' },
	                frontmatter.tags.map(function (tag, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    tag
	                  );
	                })
	              )
	            ),
	            frontmatter.collaborators.length > 0 && _react2.default.createElement(
	              'div',
	              { className: 'tags' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Collaborators'
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'simple' },
	                frontmatter.collaborators.map(function (item, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    item.website && _react2.default.createElement(
	                      'span',
	                      null,
	                      item.service,
	                      ' by',
	                      _react2.default.createElement('br', null),
	                      _react2.default.createElement(
	                        'a',
	                        { href: item.website },
	                        item.name
	                      )
	                    ),
	                    !item.website && _react2.default.createElement(
	                      'span',
	                      null,
	                      item.service,
	                      ' by',
	                      _react2.default.createElement('br', null),
	                      item.name
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Project;
	}(_react.Component);
	
	exports.default = Project;
	module.exports = exports['default'];

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _heroBanner = __webpack_require__(43);
	
	var _heroBanner2 = _interopRequireDefault(_heroBanner);
	
	var _project = __webpack_require__(44);
	
	var _project2 = _interopRequireDefault(_project);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutMe = function (_Component) {
	  _inherits(AboutMe, _Component);
	
	  function AboutMe() {
	    _classCallCheck(this, AboutMe);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  AboutMe.prototype.render = function render() {
	    var data = this.props.data;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'A little something about me',
	        meta: [{
	          name: 'description',
	          content: 'I\'m a freelance web designer and fullstack web developer based in beautiful Norfolk'
	        }] }),
	      _react2.default.createElement(
	        _heroBanner2.default,
	        { heroId: 'blue-hero', nextId: 'introduction' },
	        _react2.default.createElement(
	          'div',
	          { className: 'heading' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'About me'
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'A little something about me'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'introduction', className: 'section white' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'story-block story' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Welcome, I\'m Neil'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'I have over two decades of full stack web development experience starting in 1998 as a web developer for a small but successful organisation delivering educational learning resources. I then moved and worked for a highly successful uk online reseller before going freelance in 2009 where I now work out of my own small office in beautiful Norfolk, UK.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Since going freelance I have had the pleasure and delight to work on many client websites in many industries from hospitality and catering to manufacturing, reselling and education to name but a few.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'I have a wide range of skills and development experience but my core skills and focus has been with the Microsoft web architecture of ASP.NET where I have over 20 years of experience although more recently I have expanded my skills to include the newer emerging frameworks such as React, Angular and the MEAN stack.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section stiffkey' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper __cols' },
	          _react2.default.createElement(
	            'div',
	            { className: 'web-developer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'story' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Web Development'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'As with all things technology based the world of the web developer moves pretty quickly so keeping my skills fresh, up to date and in trend is always a challenge, and a challenge that I enjoy. My current skills include many front-end, back-end and middleware languages that provides me the necessary skills to work as a full stack developer.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'As a full stack web developer I can call upon over 20 years of experience and I am highly proficient in client-side development using the latest HTML 5, CSS and JavaScript to build fully dynamic responsive websites.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'I have over two decades of experience in the Microsoft web technologies being an early adopter of ASP.NET and moving with their development and build to now working with ASP.NET Core and ASP.NET 4 MVC although more recently I broadened my skills to include the MEAN stack allowing me to offer sites and single page applications built with NodeJs, ExpressJs, Angular and MongoDb.'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section wevet white' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'web-designer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'story' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Web Design'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'As with web development my role as a web designer is also fast moving, keeping up with the latest in design trends as well as researching and exploring the latest in front-end development to deliver clean fully responsive websites.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'I have over two decades of experience in using Adobe Photoshop to help with design as well as allowing me to easily interogate the design in order to create pixel perfect websites although more recently I have switched to Adobe Illustrator and Adobe XD which has streamlined the design process, providing cleaner design elements and allowing for easier design manipulation especially for modern responsive websites.'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section grid white' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper __cols' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'heading', 'data-tag': 'featured' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Featured project'
	            )
	          )
	        ),
	        data.allMarkdownRemark.edges.map(function (_ref, index) {
	          var node = _ref.node;
	          return _react2.default.createElement(_project2.default, { key: index, data: node });
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'section center' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: 'work', className: 'strong' },
	            'View more work'
	          )
	        )
	      )
	    );
	  };
	
	  return AboutMe;
	}(_react.Component);
	
	exports.default = AboutMe;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-me-js-477a6aa6cfe77f413688.js